/**
 * Principles page content — the four founding principles, curated from PRINCIPLES.md (the founder's
 * English prose, presented faithfully). These are load-bearing commitments the whole platform honours.
 */
export const principles = {
  eyebrow: 'Founding principles',
  title: 'What we promise',
  lede: 'Four load-bearing commitments carry everything we build. They are recorded here so they are never lost as the association grows.',
  items: [
    {
      heading: 'Free, or at cost price',
      paragraphs: [
        'Everything connected to the organisation is free, or provided at cost price. It is a non-profit run on a cost-recovery basis; any revenue only covers costs and funds the mission. Membership is free. Roles and status are earned through contribution — never through payment.',
      ],
    },
    {
      heading: 'Open to all who share the values',
      paragraphs: [
        'The organisation welcomes everyone who shares its values and those of the Enlightenment: reason, science, evidence, merit, integrity, compassion, personal responsibility, lifelong learning, open debate, democracy and transparency. Everyone is welcome.',
        'We never forbid or exclude anyone on the basis of sex, gender identity, sexual orientation, origin, ethnicity, belief, disability or any other belonging group. We wholly (100%) repudiate the historical order’s selection of people — it barred, among others, women and Jews from membership; we never will. We take the Enlightenment’s values, never its exclusion. All people are of equal worth and equally welcome, whatever their origin. Anyone may apply.',
      ],
    },
    {
      heading: 'Collaboration with kindred organisations',
      paragraphs: [
        'We gladly collaborate with other similar societies and movements, provided they do not depart from our values — reason, science, transparency, democracy, compassion and non-discrimination. Collaborations are open and documented; we make no secret agreements and never compromise the founding principles for a partner’s sake.',
      ],
    },
    {
      heading: 'Stewardship of the historical humanitarian legacy',
      paragraphs: [
        'We steward and carry forward the fine, humane work done in the past. Original material from the historical order is preserved, openly archived and integrated so that none of the good that was done is lost. Sources are cited and attributed; we take the humane and enlightened from the legacy and leave what conflicts with our values.',
      ],
    },
  ],
  motto: 'Scientia et Caritas — Knowledge & Compassion.',
} as const;
